/*
 * @Author: 孙照
 * @LastEditTime: 2024-01-02 21:05:44
 * @Description: 全局以及公共状态
 * @FilePath: \sheyang\src\store\modules\global.js
 */
import * as type from '@/store/const';
import { getStationInfo, getEnergyMap } from '@/api/overView';
import { getChargeStatus } from '@/api/stationStatistics';

const GET_STATION_LIST = 'getStationList'; // 场站列表
const GET_STATION_NUM = 'getStationNum'; // 场站数量
const GET_STATION_ID = 'getStationId'; // 场站id
const GET_CURRENT_STATION = 'getCurrentStation'; // 当前选中场站
const GET_IMG_List = 'getImgList'; // 电站图
const GET_EQUIPMENT_AMOUNT = 'getEquipmentAmount'; // 获取充电设备数量
const GET_NAV_DATA = 'getNavData'; // 获取导航数据

const global = {
  state: () => ({
    openStationDialog: false, // 电站充电详情弹框
    openPvDialog: false, // 光伏弹框
    openEnergyStorageDialog: false, // 储能统计弹框
    stationList: [], // 场站列表
    stationNum: 0, // 场站数量
    imgList: [], // 当前选中场站图片
    stationId: '', // 当前选中场站id
    currentStationId: '', // 当前选中场站id
    equipmentAmount: 0,
    navData: [
      {
        id: 0, name: '总览', url: '/', isActive: false,
      },
      {
        id: 1, name: '充电统计', url: '/chargingStats', isActive: false,
      },
      {
        id: 2, name: '光伏统计', url: '/pvStats', isActive: false,
      },
      {
        id: 3, name: '储能统计', url: '/energyStorageStats', isActive: false,
      },
      // {
      //   id: 4, name: '两轮换电统计', url: '/batterySwapStats', isActive: false,
      // },
    ],
  }),
  mutations: {
    // 充电统计地图 打开弹框
    [type.STATION_MODAL_CHANGE]: (state, flag) => {
      state.openStationDialog = flag;
    },
    // 光伏统计 弹框
    [type.STATION_PV_MODAL_CHARGE]: (state, flag) => {
      state.openPvDialog = flag;
    },
    // 站点统计
    [type.STATION_ENERGY_STORAGE_CHARGE]: (state, flag) => {
      state.openEnergyStorageDialog = flag;
    },
    // 场站列表
    [GET_STATION_LIST]: (state, commit) => {
      state.stationList = [...commit];
    },
    // 场站数量
    [GET_STATION_NUM]: (state, commit) => {
      state.stationNum = commit;
    },
    // 场站id
    [GET_STATION_ID]: (state, commit) => {
      state.stationId = commit;
    },
    // 当前选中场站id
    [GET_CURRENT_STATION]: (state, commit) => {
      state.currentStationId = commit;
    },
    [GET_IMG_List]: (state, commit) => {
      state.imgList = commit;
    },
    [GET_EQUIPMENT_AMOUNT]: (state, commit) => {
      state.equipmentAmount = commit;
    },
    [GET_NAV_DATA]: (state, commit) => {
      state.navData = [...commit];
    },
  },
  actions: {
    // 请求场站列表
    async getStationList ({ commit }, params = {}) {
      const res = await getStationInfo(params);
      const { code, data } = res;
      if (code === '200' && data.length > 0) {
        let imgList = [];
        // console.log('--请求结果---', data);
        const newStationList = [];

        data.forEach((item) => {
          const {
            id, name, location, imgUrls,
          } = item;
          const { address, gisGcj02Lat, gisGcj02Lng } = location;
          newStationList.push({
            stationId: id,
            stationName: name,
            stationAddress: address,
            coordinates: [gisGcj02Lng, gisGcj02Lat],
            ...item,
          });
          // 如果 imgUrls 为空数组或者无数据，则不进行拼接
          if (imgUrls && imgUrls.length > 0) {
            imgList = imgList.concat(imgUrls);
          }
        });
        // console.log('-----合并结果++++', newStationList);

        commit(GET_STATION_LIST, newStationList);
        commit(GET_STATION_NUM, data.length);
        commit(GET_IMG_List, imgList);
        // console.log('--场站列表+++', newStationList);
      }
    },
    // 请求场站列表
    async getEnergyMap ({ commit, dispatch }) {
      const res = await getEnergyMap();
      const { code, data } = res;
      if (code === '200' && data.length > 0) {
        // console.log('---电站数据', data);
        const newStationList = data.map((item) => {
          const { id, name, location } = item;
          const { address, gisGcj02Lat, gisGcj02Lng } = location;
          return {
            stationId: id,
            stationName: name,
            stationAddress: address,
            coordinates: [gisGcj02Lng, gisGcj02Lat],
          };
        });
        commit(GET_STATION_LIST, newStationList);
        commit(GET_STATION_NUM, data.length);
        // 调用 overview 模块 actions 的方法 stubGroupQry 并传递参数
        dispatch('overView/stubGroupQry', data[0].id, { root: true });
      }
    },
    // 获取充电枪数量
    async getEquipmentNum ({ commit }) {
      const res = await getChargeStatus();
      if (res.code === '200' && res.data) {
        let equipmentAmount = 0;
        const {
          adcCharging, adcFree, adcOffLine, adcFault, rests,
        } = res.data;
        equipmentAmount = adcCharging + adcFree + adcOffLine + adcFault + rests;
        commit(GET_EQUIPMENT_AMOUNT, equipmentAmount);
      }
    },
    changeNavItemsActive({ state, commit }, payload) {
      const { navData } = state;
      // 深拷贝 navData
      const data = JSON.parse(JSON.stringify(navData));
      // 获取当前路由 并改变对应的 isActive
      const url = payload;
      const index = data.findIndex((item) => item.url === url);
      data.forEach((item) => {
        item.isActive = false;
      });
      data[index].isActive = true;
      commit(GET_NAV_DATA, data);
    },
  },
  getters: {
    // 场站列表
    stationList: (state) => state.stationList,
    // 场站数量
    stationNum: (state) => state.stationNum,
    // 场站id
    stationId: (state) => state.stationId,
    // 当前选中场站id
    currentStationId: (state) => state.currentStationId,
    imgList: (state) => state.imgList,
    equipmentAmount: (state) => state.equipmentAmount,
    navData: (state) => state.navData,
  },
};

export default global;
